import { render, staticRenderFns } from "./LangView.vue?vue&type=template&id=752c881b&scoped=true"
import script from "./LangView.vue?vue&type=script&lang=js"
export * from "./LangView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752c881b",
  null
  
)

export default component.exports